import { useState } from "react";
import { createPortal } from "react-dom";
import { Coins, X } from "lucide-react";

/* "Stake to Earn" teaser button — opens a COMING SOON dialog on click. */
export const StakeSoonButton = ({ className = "nb-btn nb-btn--accent", label = "Stake to Earn", iconSize = 18, testid = "stake-soon-button", onOpen }) => {
  const [open, setOpen] = useState(false);
  const show = () => {
    setOpen(true);
    if (onOpen) onOpen();
  };
  return (
    <>
      <button type="button" onClick={show} className={className} data-testid={testid}>
        <Coins size={iconSize} /> {label}
      </button>
      {open && createPortal(
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/75 backdrop-blur-sm px-4"
          onClick={() => setOpen(false)}
          data-testid="stake-soon-overlay"
        >
          <div
            className="gg-panel gg-glow-gold rounded-3xl p-8 md:p-10 max-w-md w-full text-center relative"
            onClick={(e) => e.stopPropagation()}
            data-testid="stake-soon-modal"
          >
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 text-[var(--jd-ocean)] hover:text-[var(--jd-text)]"
              aria-label="Close"
              data-testid="stake-soon-close"
            >
              <X size={20} />
            </button>
            <Coins size={42} className="mx-auto text-[var(--jd-secondary)]" />
            <h3 className="font-display font-bold text-3xl uppercase mt-4 neon-title-gold" data-testid="stake-soon-title">
              Stake to Earn
            </h3>
            <p
              className="font-display font-bold text-4xl md:text-5xl uppercase mt-3 neon-title-pink animate-pulse"
              data-testid="stake-soon-badge"
            >
              SOON
            </p>
            <p className="mt-4 text-sm md:text-base text-[var(--jd-ocean)]" data-testid="stake-soon-text">
              Lock your $JETDOG and earn passive rewards while you sleep.
              The staking pool is being fueled up — stay tuned, good boys.
            </p>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default StakeSoonButton;
